import { withI18n } from 'react-i18next';

import { RegisterView } from './RegisterView';

export default withI18n()(RegisterView);
